import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import ChatIcon from '@material-ui/icons/Chat';

import TicketsManagerTabs from "../../components/TicketsManagerTabs/";
import TicketsManagerSimple from "../../components/TicketsManagerSimple";
import useUiMode from "../../hooks/useUiMode";
import Ticket from "../../components/Ticket/";
import TicketAdvancedLayout from "../../components/TicketAdvancedLayout";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import { i18n } from "../../translate/i18n";



const useStyles = makeStyles(theme => ({
    header: {
    },
    content: {
        overflow: "auto"
    },
    placeholderContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        backgroundColor: theme.palette.boxticket, //DARK MODE PLW DESIGN//
        padding: theme.spacing(3),
    },
    placeholderItem: {
    },
    // ✅ NUEVOS ESTILOS PARA MEJOR UX (igual que CHATS)
    logoContainer: {
        marginBottom: theme.spacing(3),
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    logoImage: {
        maxWidth: "450px",
        maxHeight: "450px",
        width: "auto",
        height: "auto",
        objectFit: "contain",
        imageRendering: "auto", // ✅ Mantener calidad al escalar
    },
    welcomeText: {
        marginBottom: theme.spacing(1),
        textAlign: "center",
        fontSize: "1.5rem", // ✅ Texto más grande
    },
    subtitleText: {
        marginBottom: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
        fontSize: "1rem", // ✅ Texto más grande
    },
    actionButton: {
        marginTop: theme.spacing(2),
    }
}));

const TicketAdvanced = (props) => {
	const classes = useStyles();
	const { ticketId } = useParams();
	const [option, setOption] = useState(0);
	const { isSimple } = useUiMode();
    const { currentTicket, setCurrentTicket } = useContext(TicketsContext)

    useEffect(() => {
        if(currentTicket.id !== null) {
            setCurrentTicket({ id: currentTicket.id, code: '#open' })
        }
        if (!ticketId) {
            setOption(1)
        }
        return () => {
            setCurrentTicket({ id: null, code: null })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (currentTicket.id !== null) {
            setOption(0)
        }
    }, [currentTicket])


	const logo = `${window.WATOOLX_BACKEND_URL || process.env.REACT_APP_BACKEND_URL || window.location.origin}/public/logotipos/login.png`;
    const randomValue = Math.random(); // Generate a random number
  
    const logoWithRandom = `${logo}?r=${randomValue}`;

	const renderPlaceholder = () => {
		return <Box className={classes.placeholderContainer}>
			{/* ✅ LOGO ADAPTABLE CON MEDIDAS CORRECTAS */}
			<div className={classes.logoContainer}>
				<img 
					className={classes.logoImage}
					src={logoWithRandom} 
					alt={`${(typeof process !== 'undefined' && process.env) ? process.env.REACT_APP_NAME_SYSTEM : 'Sistema'}`} 
				/>
			</div>
			
			{/* ✅ MENSAJE PRINCIPAL */}
			<Typography variant="h6" color="textPrimary" className={classes.welcomeText} style={{ fontWeight: "bold" }}>
				{i18n.t("tickets.welcome.title")}
			</Typography>
			
			{/* ✅ MENSAJE SUBLIMINAL */}
			<Typography variant="body2" color="textSecondary" className={classes.subtitleText}>
				{i18n.t("tickets.welcome.subtitle")}
			</Typography>
        </Box>
	}

	const renderMessageContext = () => {
		if (ticketId) {
			return <Ticket />
		}
		return renderPlaceholder()
	}

	const renderTicketsManagerTabs = () => {
		return <TicketsManagerTabs />
	}

	// Modo simple (doc 0446): pila tipo WhatsApp — lista o chat, el chat vuelve con ←.
	if (isSimple) {
		return (
			<TicketAdvancedLayout style={{ gridTemplateRows: "1fr" }}>
				<div style={{ minHeight: 0, height: "100%", overflow: "hidden" }}>
					{ticketId ? <Ticket /> : <TicketsManagerSimple />}
				</div>
			</TicketAdvancedLayout>
		);
	}

	return (
        <TicketAdvancedLayout>
            <Box className={classes.header}>
                <BottomNavigation
                    value={option}
                    onChange={(event, newValue) => {
                        setOption(newValue);
                    }}
                    showLabels
                    className={classes.root}
                >
                    <BottomNavigationAction label={i18n.t("tickets.mobile.bottomNav.chat")} icon={<ChatIcon />} />
                    <BottomNavigationAction label={i18n.t("tickets.mobile.bottomNav.tickets")} icon={<QuestionAnswerIcon />} />
                </BottomNavigation>
            </Box>
            <Box className={classes.content}>
                { option === 0 ? renderMessageContext() : renderTicketsManagerTabs() }
            </Box>
        </TicketAdvancedLayout>
	);
};

export default TicketAdvanced;
